import {
  ArrowDownTrayIcon,
  PencilIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import date from "date-and-time";
import { IInvoice } from "../../models/invoice/IInvoice";
import LoadingWheel from "../shared/LoadingWheel";
import { IAccount } from "../../models/account/IAccount";
import useAccountInvoices from "../../data/useAccountInvoices";
import useInvoices from "../../data/useInvoices";
import { useEffect, useState } from "react";
import InvoiceModal from "../invoices/InvoiceModal";
import InvoiceList from "../invoices/InvoiceList";

// interface AccountInvoiceRowProps {
//   invoice: IInvoice;
//   onClick: (e: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => void;
// }

// function AccountInvoiceListRow({ invoice, onClick }: AccountInvoiceRowProps) {
//   const { downloadInvoice } = useInvoices();

//   return (
//     <tr onClick={onClick} className="hover:cursor-pointer hover:bg-gray-100">
//       <td className="px-3 py-3 border text-sm">{invoice.invoiceNumber}</td>
//       <td className="px-3 py-3 border hidden sm:table-cell text-sm">
//         {date.format(new Date(invoice.invoiceDate), "DD/MM/YYYY")}
//       </td>
//       <td className="px-3 py-3 border text-sm">{invoice.reference}</td>
//       <td className="px-3 py-3 border hidden sm:table-cell text-sm">
//         {date.format(new Date(invoice.dueDate), "DD/MM/YYYY")}
//       </td>
//       <td className="px-3 py-3 border hidden sm:table-cell text-sm">
//         £{invoice.invoiceTotal}
//       </td>
//       <td className="px-3 py-3 border hidden sm:table-cell text-center text-sm">
//         <span
//           className={`px-3 py-1 rounded-full font-bold ${{
//             0: "bg-blue-100 text-blue-600",
//             1: "bg-amber-100 text-amber-600",
//             2: "bg-green-100 text-green-600",
//           }[invoice.status]
//             }`}
//         >
//           {
//             {
//               0: "Draft",
//               1: "Approved",
//               2: "Paid",
//             }[invoice.status]
//           }
//         </span>
//       </td>
//       <td className="px-3 py-3 border text-sm">
//         <div className="px-3 flex justify-center space-x-4">
//           <ArrowDownTrayIcon className="w-5 h-5 text-gray-600" onClick={(e) => { e.stopPropagation(); downloadInvoice(invoice.id); }} />
//           {/* <TrashIcon 
//             className="w-5 h-5 text-gray-600 hover:text-red-600 transition-colors" 
//             onClick={(e) => {
//               e.stopPropagation();
//             }} 
//           /> */}
//         </div>
//       </td>
//     </tr>
//   );
// }

export default function AccountInvoiceList({ account }: { account: IAccount }) {

  return <div className="mb-24"><InvoiceList accountId={account.id} /></div>;

  // const { accountInvoices } = useAccountInvoices(account.id);

  // const [openModal, setOpenModal] = useState(false);
  // const [invoice, setInvoice] = useState<IInvoice | null>(null);

  // useEffect(() => {
  //   if (openModal) return;
  //   setInvoice(null);

  // }, [openModal])

  // if (accountInvoices.isLoading) {
  //   return (
  //     <div className="flex items-center justify-center py-10">
  //       <LoadingWheel />
  //     </div>
  //   );
  // } else if (
  //   accountInvoices.isError ||
  //   !accountInvoices.data ||
  //   !accountInvoices.data.data
  // ) {
  //   return (
  //     <div className="flex items-center justify-center py-10">
  //       <p className="text-red-600 font-bold text-xl">Error loading invoices</p>
  //     </div>
  //   );
  // } else {
  //   return (
  //     <div>
  //       <InvoiceModal
  //         open={openModal}
  //         setOpen={setOpenModal}
  //         invoice={invoice}
  //       />

  //       <div className="sm:hidden p-2">
  //         <p className="text-center">Tap a row to see the full record</p>
  //       </div>
  //       <table className="min-w-full divide-y border-collapse divide-gray-300">
  //         <thead>
  //           <tr className="bg-primary-50 text-gray-800">
  //             <th className="py-3.5 px-3 text-sm font-semibold text-left">
  //               Invoice No
  //             </th>
  //             <th className="py-3.5 px-3 text-sm font-semibold hidden sm:table-cell text-left">
  //               Invoice Date
  //             </th>
  //             <th className="py-3.5 px-3 text-sm font-semibold text-left">
  //               Reference
  //             </th>
  //             <th className="py-3.5 px-3 text-sm font-semibold hidden sm:table-cell text-left">
  //               Due Date
  //             </th>
  //             <th className="py-3.5 px-3 text-sm font-semibold hidden sm:table-cell text-left">
  //               Total
  //             </th>
  //             <th className="py-3.5 px-3 text-sm font-semibold hidden sm:table-cell text-left">
  //               Status
  //             </th>
  //             <th className="py-3.5 px-3 text-sm font-semibold text-left">
  //               Actions
  //             </th>
  //           </tr>
  //         </thead>
  //         <tbody>
  //           {accountInvoices.data.data.map((invoice) => (
  //             <AccountInvoiceListRow
  //               key={invoice.id}
  //               invoice={invoice}
  //               onClick={(e) => {
  //                 e.stopPropagation();
  //                 setInvoice({ ...invoice, account: account });
  //                 setOpenModal(true);
  //               }}
  //             />
  //           ))}
  //         </tbody>
  //       </table>
  //     </div>
  //   );
  // }
}
